import * as z from "zod/v4";

export const deleteThirdPartyBillingAccount = {
  name: "deleteThirdPartyBillingAccount" as const,
  input: z.object({ accountId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
